import React, { Component } from "react";
//STYLE
import "../CSS/style_error_message.css";
//ICON
import IconError from "material-ui/svg-icons/alert/error";

export default class ErrorMessage extends Component {
  constructor(props) {
    super(props);

    this.state = {
        timer : null,
        visible : false
    }
  }

  componentWillReceiveProps(nextProps){
    if(nextProps.message === "" || nextProps.message === null) return;
    this.setState({
        visible : true,
        timer : setTimeout( () => this.setState({ visible : false, timeout: null }) , 2500)
    });
  }

  render() {
    return(
        (this.state.visible && (this.props.message !== null || this.props.message !== "") ) && 
        <div className="error-container">
             <IconError/> {this.props.message}
        </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/Components/component_MsgError.js